module.exports = __webpack_public_path__ + "img/opening-booking.82637afc.png";